import React, { useEffect } from 'react';

const useEffectOnceWhen = (
	condition: boolean,
	f: () => any,
	deps: any[] = []
) => {
	const runOnceRef = React.useRef(false);

	useEffect(() => {
		if (!runOnceRef.current && condition) {
			runOnceRef.current = true;
			return f();
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [...deps, condition, f]);
};

export default useEffectOnceWhen;
